import {ExportType} from "@/shared/timrTypes";
import * as BootstrapModal from "@/shared/ui/bootstrapModal";


export interface ProjectTimeReportSelection {
	grouping: string;
	includeAttachments: boolean;
}

export class SelectProjectTimeReportDialog {

	private container: JQuery;
	private dialog: BootstrapModal.Modal;
	/** Resolver of the promise returned by the current {@link show} call. */
	private resolveSelection?: (selection: ProjectTimeReportSelection) => void;

	constructor(container: JQuery) {
		this.container = container;
		this.init();
	}

	/** Resolves with the selected report options; never resolves if the dialog is cancelled. */
	public show(exportType: ExportType): Promise<ProjectTimeReportSelection> {
		this.container.find(`[data-visible-for-export-type]`).each((_, el) => {
			const $el = $(el);
			$el.toggle($el.attr("data-visible-for-export-type")?.includes(exportType));
		});
		this.dialog.show();
		return new Promise(resolve => {
			this.resolveSelection = resolve;
		});
	}

	private init() {
		const includeAttachmentsCheckbox = this.container.find(`input[name="includeAttachments"]`);
		this.dialog = new BootstrapModal.Modal({
			title: "selectProjectTimeReport.header",
			message: this.container,
			buttons: [{
				text: "dialog.create.report",
				action: () => {
					const grouping = this.container.find(`select[name="projectTimeReportGrouping"]`).val() as string;
					const includeAttachments = includeAttachmentsCheckbox.is(":checked");
					if (grouping) {
						this.resolveSelection?.({grouping, includeAttachments});
						this.dialog.close();
					}
				},
				css: "btn-primary"
			}, {
				text: "dialog.cancel"
			}]
		});
		includeAttachmentsCheckbox.on("click", () => {
			const checked = includeAttachmentsCheckbox.is(":checked");
			$("#includeAttachmentsInfo").toggle(checked);
		})
	}
}

